export const formatNotificationTime = (timestamp: string): string => {
  const now = new Date();
  const time = new Date(timestamp);
  const diffMs = now.getTime() - time.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);

  if (diffSeconds < 60) return "Just now";
  if (diffMinutes < 60) return `${diffMinutes} min ago`;
  if (diffHours < 24 && now.toDateString() === time.toDateString()) return "Today";

  const startOfWeek = new Date(now);
  startOfWeek.setDate(now.getDate() - now.getDay());
  startOfWeek.setHours(0, 0, 0, 0);
  if (time >= startOfWeek) return "This week";

  if (now.getMonth() === time.getMonth() && now.getFullYear() === time.getFullYear()) {
    return "This month";
  }

  return time.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

interface NotificationLike {
  createdAt?: string | number;
  requestEpoch?: string | number;
}

export function formatTimestamp(notification: NotificationLike): string {
  const raw = notification?.createdAt ?? notification?.requestEpoch;
  if (!raw) return "";

  const epoch = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(epoch)) return String(raw);
  const ms = epoch < 1e12 ? epoch * 1000 : epoch;

  try {
    return new Date(ms).toLocaleString();
  } catch {
    return "";
  }
}
